export class UpdateSellerTradeDataTransactionsError extends Error {}
